import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Utils } from '../../../../utils/utils';
import { HttpClient } from '@angular/common/http';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';
import { AssessmentListComponent } from './assessment-list/assessment-list.component';
import { Observable, Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { ActionPriorizationListComponent } from './action-priorization-list/action-priorization-list.component';
import { Router } from '@angular/router';
import { CustomDialogService } from '../../../../services/customdialog.service';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { BranchExcellenceService } from 'src/app/services/branchexcellence.service';

@Component({
    selector: 'assessment',
    templateUrl: './assessment.component.html',
    styleUrls: ['./assessment.component.less', '../../../../style/container-tab-list.component.less', '../../../../style/new-generic-styles.component.less'],
    standalone: false
})
export class AssessmentComponent implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild(AssessmentListComponent) assessmentViewList: AssessmentListComponent = {} as AssessmentListComponent;
    @ViewChild(ActionPriorizationListComponent) prioritiesViewList: ActionPriorizationListComponent = {} as ActionPriorizationListComponent;
    @ViewChild(MatSlideToggle) bestPracticesToggle: MatSlideToggle = {} as MatSlideToggle;
    private readonly _destroying$ = new Subject<void>();

    assessmentInfo: Assessment | undefined;
    childData: any[] = [];
    stages: ExcellenceStage[] = [];
    priorities: Priority[] = [];
    subscriptionWaveId: any;
    subscriptionlang: any;
    subscriptions: any[] = [];
    subscriptionMgmtId: any;

    label: string = '';
    waveId: number = -1;
    private currentLoadingWaveId: number | undefined;
    isEditModeEnabled: boolean = false;
    showImprovementLeversTab: boolean = false;
    isExcelModeEnabled = false;
    stageKPIWarning = `**Please fill in all Stage KPI Results before completing the assessment`;
    leversMandatoryFieldsWarning = `**Please fill in all mandatory Priority and Improvement KPI fields`;

    constructor(
        private http: HttpClient
        , @Inject('BASE_URL') private baseUrl: string
        , public defaults: DefaultValuesService
        , private toastrService: ToastrService
        , private customDialog: CustomDialogService
        , private readonly branchExcellenceService: BranchExcellenceService
        , private router: Router
        , private datePipe: DatePipe) { }

    ngOnInit(): void {
        this.getExcellenceStages();
        this.getPriorities();
        
    }
    ngAfterViewInit() {
        this.subscriptionlang = this.defaults.languageMessageChanges$.subscribe(() => {
            if (this.waveId) {
                this.reload();
            }
        });
        this.subscriptionMgmtId = this.defaults.managementIdMessageChanges$.subscribe(() => {
            if (this.waveId) {
                this.reload();
            }
        });
        this.subscriptionWaveId = this.defaults.wave$.subscribe(
            (waveId: number | undefined) => {
                if (waveId) {
                    this.waveId = waveId;
                    this.reload()
                }
            })
        if (this.defaults.waveId)
            this.loadInformation(this.defaults.waveId)
    }
    reload() {
        this.assessmentViewList?.clearSelectedFactorValues?.();
        this.loadInformation(this.waveId)
    }

    onBranchConfigSaved(waveId: number) {
        this.loadInformation(waveId);
    }

    // unsubscribe to events when component is destroyed
    ngOnDestroy(): void {
        this.subscriptionWaveId.unsubscribe();
        this.subscriptionMgmtId.unsubscribe();
        this._destroying$.next(undefined);
        this._destroying$.complete();
    }


    loadInformation(waveId) {
        this.currentLoadingWaveId = waveId;
        this.childData = [];
        if (!waveId || waveId < 0) {
            this.label = `There is no assigned wave for ${this.defaults.managementid}`
            this.assessmentInfo = undefined
            return;
        }
        this.isEditModeEnabled = this.showImprovementLeversTab = false;
        if (this.assessmentViewList)
            this.assessmentViewList.updatedItems = [];
        if (this.prioritiesViewList)
            this.prioritiesViewList.updatedItems = [];
        Utils.httpGetAssessmentInformation(
            this.http
            , this.baseUrl
            , waveId
            , this
            , function (tthis: AssessmentComponent, result: Assessment) {
                if (tthis.currentLoadingWaveId !== waveId) return;
                setTimeout(() => {
                    tthis.assessmentInfo = result
                    let indexCounter = 0;

                    const tempArray: any = []
                    tthis.assessmentInfo?.Functions.forEach((za: AssessmentFunction) => {
                        za.LineOfBusinesses.forEach((y: AssessmentLineOfBusiness) => {
                            y.ExcellenceLevers.forEach((z: AssessmentExcellenceLever) => {
                                tempArray.push({
                                    ...z,
                                    Function: za.Function,
                                    LineOfBusiness: y.LineOfBusiness,
                                    Index: indexCounter++,
                                    VisibleImprovementLevers: z.Action && z.Action?.trim() !== ''
                                })
                            })
                        })
                    })
                    tthis.childData = tempArray
                    tthis.label = `Start Date [${tthis.datePipe.transform(tthis.assessmentInfo?.StartDate, 'yyyy-MM-dd')}] End Date [${tthis.datePipe.transform(tthis.assessmentInfo?.EndDate, 'yyyy-MM-dd')}]`
                }, 50)
            }
            , function (tthis: AssessmentComponent, error: string) {
                tthis.toastrService.error('Cannot load assessment information for selected wave - Field Branch. Please, contact with administrator');
            }
        )
    }

    getExcellenceStages() {
        Utils.httpGetExcellenceStages(
            this.http
            , this.baseUrl
            , this
            , function (tthis: AssessmentComponent, result: ExcellenceStage[]) {
                setTimeout(() => {
                    tthis.stages = result
                }, 50)
            }
            , function (tthis: AssessmentComponent, error: string) {
                tthis.assessmentInfo = undefined
                tthis.childData = [];
            }
        );
    }

    getPriorities() {
        Utils.httpGetPriorities(
            this.http
            , this.baseUrl
            , this
            , function (tthis: AssessmentComponent, result: Priority[]) {
                setTimeout(() => {
                    tthis.priorities = result
                }, 50)
            }
            , function (tthis: AssessmentComponent, error: string) {
                tthis.assessmentInfo = undefined
                tthis.childData = [];
            }
        );
    }

    onClickSave(type: string) {
        const data: any[] = [];

        switch (type) {
            case 'assessment':
                const assessmentData = (this.assessmentViewList.dataSource.data as AssessmentExcellenceLever[])
                assessmentData.forEach(x => {
                    if (this.assessmentViewList.updatedItems.includes(x.WaveExcellenceLeverConfigId)) {
                        x.Waveid = this.waveId;
                        x.ManagementId = this.defaults.managementid;
                        data.push(x)
                    }
                })
                Utils.httpPostAssessmentInformation(
                    this.http,
                    this.baseUrl,
                    this.waveId,
                    data,
                    this,
                    function (tthis: AssessmentComponent, result: any) {
                        if (result) {
                            tthis.toastrService.success('Assessment information was saved successfully!');
                            tthis.loadInformation(tthis.waveId)
                        }
                        else
                            tthis.toastrService.error('Assessment information could not be saved. Please, contact with administrator');
                    },
                    null
                )
                break;
            case 'priorities':
                if (!this.validatePrioritiesRequiredFields()) {
                    this.toastrService.warning('Priority and Improvement KPI are required for all rows.');
                    return;
                }
                const prioritiesData = (this.prioritiesViewList.dataSource.data as AssessmentExcellenceLever[]);
                prioritiesData.forEach(x => {
                    if (this.prioritiesViewList.updatedItems.includes(x.WaveExcellenceLeverConfigId)) {
                        x.Waveid = this.waveId;
                        x.ManagementId = this.defaults.managementid;
                        data.push(x)
                    }
                })
                Utils.httpPostAssessmentInformation(
                    this.http,
                    this.baseUrl,
                    this.waveId,
                    data,
                    this,
                    function (tthis: AssessmentComponent, result: any) {
                        if (result) {
                            tthis.toastrService.success('Action priorization information was saved successfully!');
                            tthis.loadInformation(tthis.waveId)
                        }
                        else
                            tthis.toastrService.error('Action priorization information could not be saved. Please, contact with administrator');
                    },
                    null
                )
                break;
        }
    }

    onClickEdit() {
        if (this.isEditModeEnabled === true) {
            this.isEditModeEnabled = false
            if (this.assessmentViewList.updatedItems.length > 0 || this.prioritiesViewList.updatedItems.length > 0) {
                this.assessmentViewList.clearSelectedFactorValues();
                this.loadInformation(this.waveId)
            }
        }
        else {
            this.isEditModeEnabled = true
        }
    }

    getShowImprovementLeverTab() {
        return this.childData.some(item => item.VisibleImprovementLevers === true);
    }

    onClickExcel() {
        this.isExcelModeEnabled = true;
        this.isEditModeEnabled = false;
    }

    onClickExitExcel() {
        this.isExcelModeEnabled = false;
    }

    onClickDownloadAssesmentConfig() {
        Utils.httpDownloadAssessmentConf(
            this.http,
            this.baseUrl,
            `AssessmentConf`,
            this.waveId,
            this.defaults.managementid
        );
    }

    onClickUploadAssesmentConfig() {
        this.router.navigate(["file/" + Utils.getFileUploadAssessmentConf() + "-" + this.waveId +"-"+ this.defaults.managementid]);
    }

    onClickDownloadImprovementLevers() {
        Utils.httpDownloadImprovementLevers(
            this.http,
            this.baseUrl,
            `ImprovementLevers`,
            this.waveId
        );
    }

    onClickUploadImprovementLevers() {
        this.router.navigate(["file/" + Utils.getFileUploadImprovementLevers() + "-" + this.waveId]);  
    }

    canEdit() {
        return this.defaults.isMersyAdminBranchExcellenceUser
            || this.defaults.isMersyCoachBranchExcellenceUser;
    }

    validatePrioritiesRequiredFields(): boolean {
        let isValid = true;
        const prioritiesData = (this.prioritiesViewList.dataSource.data as AssessmentExcellenceLever[]);
        for (const lever of prioritiesData) {
            if (lever.PriorityId == null || lever.KpiDefinitionId == null) {
                isValid = false;
            }
        }
        this.prioritiesViewList.dataSource.data = [...prioritiesData];
        return isValid;
    }

    onToggleChangeBestPractices(checked: boolean): void {
        if (!this.defaults.isMersyAdminBranchExcellenceUser)
        {
            this.bestPracticesToggle.checked = !checked;
            return;
        }

        const previousValue = !checked;

        this.customDialog.openConfirm({
            title: "Delete Excellence Factor",
            message: `Are you sure you want to ${checked ? 'activate' : 'deactivate'} best practices?`,
            caller: this
        });
        this.customDialog.confirmed().subscribe(res => {
            if (!res.confirmed)
            {
                this.bestPracticesToggle.checked = previousValue;
                this.toastrService.error('Operation cancelled');
                return;
            }

            if (res.confirmed) {
                this.branchExcellenceService.updateAssessmentBestPractices(
                    this.defaults.managementid
                    , this.waveId
                    , checked
                    , function (tthis: AssessmentComponent, callResult : boolean) {
                        if (callResult)
                        {
                            tthis.bestPracticesToggle.checked = checked;
                            tthis.assessmentInfo!.IsBestPracticesCollected = checked;
                            tthis.toastrService.success('Best Practices succesfully updated');
                            return;
                        }
                        
                        tthis.bestPracticesToggle.checked = previousValue;
                        tthis.toastrService.error('Change was not save. Check that you are calling the right assessment.');
                    }
                    , function (tthis: AssessmentComponent, error: string) {
                        tthis.bestPracticesToggle.checked = previousValue;
                        tthis.toastrService.error('Cannot save best practices. Please, contact with administrator');
                    }
                    , this
                )
            }
        })
    }    
}
